<template>
  <div class="modaladmin">
    <div class="modaladmin-content">
      <div class="error" v-for="(error, index) in errors" v-bind:key="index">{{ error }}</div>
      <div>
        IME:
        <input type="text" v-model="event.name" />
      </div>
      <div>
        OPIS:
        <input type="text" v-model="event.description" />
      </div>
      <div>
        SNIMKA:
        <input type="text" v-model="event.footageLink" />
      </div>
      <div>
        POČETAK:
        <DateTimePicker format="YYYY-MM-DD hh:mm a" v-model="event.starts" />
      </div>
      <div>
        KRAJ:
        <DateTimePicker format="YYYY-MM-DD hh:mm a" v-model="event.ends" />
      </div>
      <div>
        MAX SUDIONIKA:
        <input type="number" min="0" v-model="event.maxParticipants" />
      </div>
      <div>
        PROSTORIJA:
        <select v-model="event.venue">
          <option v-bind:value="null">Nepoznato</option>
          <option v-for="venue in venues" v-bind:value="venue" v-bind:key="venue.id">{{ venue.name }}</option>
        </select>
      </div>
      <div>
        TIP:
        <select v-model="event.type">
          <option v-for="eventType in eventTypes" v-bind:value="eventType" v-bind:key="eventType">
            {{ eventType }}
          </option>
        </select>
      </div>
      <div>
        TEMA:
        <select v-model="event.theme">
          <option v-bind:value="null">Nema</option>
          <option v-for="eventTheme in eventThemes" v-bind:value="eventTheme" v-bind:key="eventTheme">
            {{ eventTheme }}
          </option>
        </select>
      </div>
      <div>
        ACHIEVEMENT KOD:
        <select v-model="event.achievementCode">
          <option v-bind:value="null">Nema</option>
          <option
            v-for="achievementCode in achievementCodes"
            v-bind:value="achievementCode"
            v-bind:key="achievementCode.id"
          >
            {{ achievementCode.code }} {{ achievementCode.description }}
          </option>
        </select>
      </div>
      <div>
        ISTAKNUT:
        <input type="checkbox" v-model="event.isFeatured" />
      </div>
      <div>
        PREDAVAČI:
        <multiselect
          v-model="eventLecturers"
          track-by="id"
          v-bind:custom-label="customLabel"
          v-bind:options="speakers"
          v-bind:multiple="true"
          v-bind:close-on-select="false"
        >
          <template slot="option" slot-scope="props">
            <span>{{ props.option.firstName }} {{ props.option.lastName }}</span>
          </template>
        </multiselect>
      </div>
      <div>
        SUPREDAVAČI:
        <multiselect
          v-model="eventCoLecturers"
          track-by="id"
          v-bind:custom-label="customLabel"
          v-bind:options="speakers"
          v-bind:multiple="true"
          v-bind:close-on-select="false"
        >
          <template slot="option" slot-scope="props">
            <span>{{ props.option.firstName }} {{ props.option.lastName }}</span>
          </template>
        </multiselect>
      </div>
      <div>
        MODERATORI:
        <multiselect
          v-model="eventModerators"
          track-by="id"
          v-bind:custom-label="customLabel"
          v-bind:options="speakers"
          v-bind:multiple="true"
          v-bind:close-on-select="false"
        >
          <template slot="option" slot-scope="props">
            <span>{{ props.option.firstName }} {{ props.option.lastName }}</span>
          </template>
        </multiselect>
      </div>
      <div>
        FIRME:
        <multiselect
          v-model="eventCompanies"
          track-by="id"
          label="name"
          v-bind:options="companies"
          v-bind:multiple="true"
          v-bind:close-on-select="false"
        >
          <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
        </multiselect>
      </div>
      <div class="modaladmin-footer">
        <button type="button" v-bind:disabled="!event.name || !event.name.length" v-on:click="validateAndSave">
          SPREMI
        </button>
        <button type="button" v-on:click="$emit('cancel', event)">ODUSTANI</button>
      </div>
    </div>
    <a aria-label="Zatvori popup" class="close-modaladmin" v-on:click="$emit('cancel', event)"></a>
  </div>
</template>

<script>
import DateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
import Multiselect from 'vue-multiselect';

export default {
  name: 'AddEditEventModal',
  data() {
    return {
      errors: [],
      eventLecturers: [],
      eventCoLecturers: [],
      eventModerators: [],
      eventCompanies: [],
    };
  },
  components: {
    DateTimePicker,
    Multiselect,
  },
  props: {
    event: {},
    eventTypes: Array,
    eventThemes: Array,
    speakers: Array,
    venues: Array,
    companies: Array,
    achievementCodes: Array,
  },
  methods: {
    validateAndSave: function() {
      if (this.validate()) {
        this.event.eventUsers = [];
        this.event.eventCompanies = [];

        for (let lecturer of this.eventLecturers)
          this.event.eventUsers.push({
            user: lecturer,
            userEventRole: 'Speaker',
          });

        for (let coLecturer of this.eventCoLecturers)
          this.event.eventUsers.push({
            user: coLecturer,
            userEventRole: 'AssistantSpeaker',
          });

        for (let moderator of this.eventModerators)
          this.event.eventUsers.push({
            user: moderator,
            userEventRole: 'Moderator',
          });

        for (let company of this.eventCompanies) this.event.eventCompanies.push({ company: company });

        this.$emit('save', this.event);
      }
    },
    validate: function() {
      this.errors = [];

      if (!this.event.name) this.errors.push('Ime ne može biti prazno.');
      if (new Date(this.event.starts) > new Date(this.event.ends))
        this.errors.push('Neispravan unos za početni i krajnji datum');
      if (isNaN(this.event.maxParticipants) || this.event.maxParticipants < 0)
        this.errors.push('Nisu uneseni ispravni brojevi za max sudionike i/ili max sudionike bez laptopa.');

      let userIds = [
        ...this.eventLecturers.map(lecturer => lecturer.id),
        ...this.eventCoLecturers.map(coLecturer => coLecturer.id),
        ...this.eventModerators.map(moderator => moderator.id),
      ];

      let areThereDuplicateIds = new Set(userIds).size !== userIds.length;

      if (areThereDuplicateIds) this.errors.push('Isti korisnik ne može biti u više uloga na eventu!');

      if (this.errors.length) return false;

      return true;
    },
    customLabel: function({ firstName, lastName }) {
      return `${firstName} ${lastName}`;
    },
  },
  created() {
    if (!this.event.type) this.event.type = 'Lecture';

    if (!this.event.theme) this.event.theme = null;

    if (!this.event.venue) this.event.venue = null;

    if (!this.event.maxParticipants) this.event.maxParticipants = 0;

    if (this.event.eventUsers && this.event.eventUsers.length) {
      this.eventLecturers.push(
        ...this.event.eventUsers.filter(eu => eu.userEventRole === 'Speaker').map(eu => eu.user),
      );
      this.eventCoLecturers.push(
        ...this.event.eventUsers.filter(eu => eu.userEventRole === 'AssistantSpeaker').map(eu => eu.user),
      );
      this.eventModerators.push(
        ...this.event.eventUsers.filter(eu => eu.userEventRole === 'Moderator').map(eu => eu.user),
      );
    }

    if (this.event.eventCompanies && this.event.eventCompanies.length)
      this.eventCompanies.push(...this.event.eventCompanies.map(ec => ec.company));

    if (!this.event.achievementCode) this.event.achievementCode = null;
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>
